/**
 * DEV-2018 (эпик DEV-2005). Видеовстречи с клиентом.
 *
 * Нейминг держим как в макетах: сущность везде «Видеовстреча» — её нельзя
 * путать со «Встречами» трекера (DEV-1969), а чип типа связанной задачи
 * называется просто «Встреча».
 */

const ru = {
  common: { navigation: { videomeetings: 'Видеовстречи' } },
  videomeetings: {
    title: 'Видеовстречи',
    schedule: 'Назначить встречу',
    empty: 'Видеовстреч пока не было',
    join: 'Подключиться',
    openLink: 'Открыть ссылку',
    joinNow: 'Присоединиться к встрече',
    copyLink: 'Ссылка',
    linkCopied: 'Ссылка скопирована',
    channelPending: 'Отправлено, ждём подтверждения провайдера',
    reschedule: 'Перенести…',
    cancel: 'Отменить',
    retry: 'Повторить',
    artifacts: 'Транскрипт и черновик квалификации',
    minutes: '{count} мин',
    loadError: 'Не удалось загрузить видеовстречи',
    // DEV-2086 (эпик DEV-2082). Раздел «Видеовстречи» и страница деталей.
    lead: { hot: 'Горячий', warm: 'Тёплый', cold: 'Холодный' },
    list: {
      title: 'Видеовстречи',
      subtitle: 'Встречи с клиентами в Google Meet и Телемосте: записи, транскрипты и разбор',
      presets: {
        aria: 'Срез списка',
        upcoming: 'Предстоящие',
        past: 'Прошедшие',
        awaiting: 'Ждут разбора',
        all: 'Все',
      },
      filters: {
        allManagers: 'Все менеджеры',
        period: 'Период',
        anyProvider: 'Площадка: любая',
        anyStatus: 'Статус: любой',
        lead: 'Лид',
        anyUsefulness: 'Полезность: любая',
        usefulnessFrom: 'Полезность: от {score}',
        client: 'Клиент…',
        toggle: 'Фильтры',
      },
      sort: {
        dateDesc: 'Сначала новые',
        dateAsc: 'Сначала старые',
        temperature: 'Горячие сверху',
        usefulness: 'Полезные сверху',
      },
      stats: {
        total: 'Встреч за период',
        hot: 'Горячих лидов',
        awaiting: 'Ждут разбора',
        usefulness: 'Средняя полезность',
      },
      columns: {
        when: 'Дата и время',
        client: 'Клиент',
        manager: 'Менеджер',
        provider: 'Площадка',
        status: 'Статус',
        lead: 'Лид',
        usefulness: 'Полезность',
      },
      unnamedClient: 'Клиент без имени',
      deal: 'Сделка',
      open: 'Открыть',
      empty: {
        title: 'Видеовстреч пока нет',
        description: 'Назначьте встречу из карточки клиента или сделки — она появится здесь',
      },
      emptyFiltered: {
        title: 'По этим фильтрам встреч нет',
        description: 'Смените срез или сбросьте фильтры',
      },
      resetFilters: 'Сбросить фильтры',
      loadError: 'Не удалось загрузить список встреч',
    },
    insights: {
      empty: 'Разбора ещё нет',
      sentiment: 'Настроение',
      sentiments: {
        SENTIMENT_POSITIVE: '😊 позитивное',
        SENTIMENT_NEUTRAL: '😐 нейтральное',
        SENTIMENT_NEGATIVE: '😟 негативное',
      },
      topics: 'Темы',
      objections: 'Возражения',
      risks: 'Риски',
      agreements: 'Договорённости',
    },
    info: {
      title: 'Встреча',
      client: 'Клиент',
      deal: 'Сделка',
      manager: 'Менеджер',
      provider: 'Площадка',
      recording: 'Запись',
      on: 'Включена',
      off: 'Выключена',
      consent: 'Согласие',
      task: 'Задача «Встреча»',
      taskCreated: 'Создана',
      taskMissing: 'Не создана',
      created: 'Назначена',
    },
    invites: {
      title: 'Приглашения',
      empty: 'Приглашения не отправлялись',
      resend: 'Повторить',
      resent: 'Приглашение отправлено повторно',
      resendError: 'Не удалось отправить повторно',
      sent: 'доставлено {when}',
      pending: 'ждём подтверждения',
      failed: 'не доставлено',
    },
    providers: {
      MEETING_PROVIDER_MEET: 'Google Meet',
      MEETING_PROVIDER_TELEMOST: 'Яндекс Телемост',
    },
    statuses: {
      MEETING_STATUS_SCHEDULED: 'Запланирована',
      MEETING_STATUS_STARTED: 'Идёт сейчас',
      MEETING_STATUS_ENDED: 'Завершена',
      MEETING_STATUS_PROCESSING: 'Обработка записи',
      MEETING_STATUS_READY: 'Готово',
      MEETING_STATUS_QUALIFIED: 'Разобрана',
      MEETING_STATUS_NO_RECORDING: 'Запись не найдена',
      MEETING_STATUS_FAILED: 'Ошибка обработки',
      MEETING_STATUS_CANCELLED: 'Отменена',
    },
    hints: {
      MEETING_STATUS_STARTED: 'запись идёт',
      MEETING_STATUS_PROCESSING: 'запись обрабатывается, транскрипт появится автоматически',
      MEETING_STATUS_READY: 'аудио и транскрипт готовы',
      MEETING_STATUS_NO_RECORDING: 'записи так и не появилось — отметьте исход встречи',
    },
    telemostBanner:
      'Запись в Телемосте включается вручную: в начале встречи нажмите «Записать на Яндекс Диск»',
    channels: {
      INVITE_CHANNEL_WHATSAPP: 'WhatsApp',
      INVITE_CHANNEL_TELEGRAM: 'Telegram',
      INVITE_CHANNEL_ZALO: 'Zalo',
      INVITE_CHANNEL_EMAIL: 'Email',
      INVITE_CHANNEL_CALENDAR: 'Календарь',
      INVITE_CHANNEL_MANUAL_COPY: 'Вручную',
    },
    modal: {
      title: 'Новая видеовстреча',
      client: 'Клиент',
      manager: 'Менеджер',
      provider: 'Площадка',
      when: 'Дата и время',
      duration: 'Длительность',
      durationValue: '{count} минут',
      recording: 'Запись разговора',
      recordingOn: 'Включена',
      recordingOff: 'Выключена',
      recordingHint: 'Клиент получит уведомление о записи в тексте приглашения',
      channels: 'Куда отправить приглашение',
      noChannels: 'У клиента нет подключённых каналов — приглашение придётся отправить вручную',
      preview: 'Текст приглашения',
      previewPending: 'Текст появится после создания встречи',
      createTask: 'Создать задачу «Встреча»',
      createTaskHint: 'Задача с типом «Встреча» и сроком в момент встречи появится в календаре',
      conflict: 'В это время у менеджера уже что-то стоит — встречу можно назначить всё равно',
      noMailbox:
        'У менеджера нет рабочего ящика в домене компании — видеовстречу от его имени назначить нельзя. Обратитесь к администратору.',
      submit: 'Назначить встречу',
      created: 'Видеовстреча назначена',
      createError: 'Не удалось назначить видеовстречу',
      telemostHint:
        'В Телемосте запись включается вручную — не забудьте нажать «Записать на Яндекс Диск»',
    },
    rescheduleModal: {
      title: 'Перенос видеовстречи',
      current: 'Сейчас назначена на {when}',
      hint: 'Клиенту уйдёт уведомление о переносе теми же каналами, срок задачи обновится',
      submit: 'Перенести',
      done: 'Встреча перенесена',
      error: 'Не удалось перенести встречу',
    },
    cancelModal: {
      title: 'Отменить видеовстречу?',
      reason: 'Причина для клиента (необязательно)',
      hint: 'Клиенту уйдёт уведомление об отмене, задача «Встреча» будет снята.',
      submit: 'Отменить встречу',
      done: 'Встреча отменена',
      error: 'Не удалось отменить встречу',
    },
    detail: {
      breadcrumb: 'Видеовстреча',
      title: 'Видеовстреча · {when}',
      listen: 'Слушать запись',
      transcript: 'Транскрипт',
      transcriptSearch: 'Поиск по транскрипту',
      transcriptEmpty: 'Расшифровки пока нет',
      showAll: 'Показать все реплики ({count})',
      backToList: 'Видеовстречи',
      titleFull: '{client} · {when} · {duration}',
      usefulnessBadge: 'Полезность {score}',
      scheduledNote:
        'Встреча ещё не состоялась. После записи здесь появятся резюме, транскрипт и предложения по карточке.',
      noRecordingsAccess: 'Запись и транскрипт доступны только с правом на записи разговоров',
      meta: {
        recordingOn: 'Запись включена',
        recordingOff: 'Без записи',
        consent: {
          RECORDING_CONSENT_NOTIFIED: 'клиент уведомлён',
          RECORDING_CONSENT_CONFIRMED: 'согласие подтверждено',
          RECORDING_CONSENT_REFUSED: 'клиент отказался',
        },
      },
      actions: {
        copyLink: 'Скопировать ссылку',
        requalify: 'Разобрать заново',
        requalified: 'Встреча разобрана заново',
        requalifyError: 'Не удалось разобрать заново',
        rescheduled: 'Встреча перенесена',
      },
      summary: 'Резюме встречи · AI',
      speakers: {
        manager: 'Менеджер',
        client: 'Клиент',
        other: 'Участник',
      },
      processing: 'Запись обрабатывается — транскрипт появится автоматически',
      failed: 'Обработка записи не удалась',
      noRecording: 'Записи этой встречи нет',
      audioError: 'Не удалось получить ссылку на аудио',
      loadError: 'Не удалось загрузить встречу',
    },
    qualification: {
      title: 'Черновик квалификации',
      hint: 'Отметьте, что применить к карточке клиента: текущее значение → предложение ИИ',
      empty: 'Модель не услышала ничего, чего ещё нет в карточке',
      apply: 'Применить выбранное ({count})',
      discard: 'Отклонить',
      applied: 'Карточка клиента обновлена',
      discarded: 'Черновик отклонён',
      applyError: 'Не удалось применить предложения',
      resolvedApplied: 'Черновик уже применён',
      resolvedDiscarded: 'Черновик отклонён — новая встреча заведёт новый',
      note: 'Резюме добавится заметкой к клиенту, а если встреча по сделке — и комментарием в неё',
      fields: {
        purchase_goal: 'Цель покупки',
        deal_timeline: 'Срок покупки',
        budget: 'Бюджет',
        interested_property_types: 'Тип объекта',
        interested_locations: 'Локации',
        note: 'Заметка',
        deal_price: 'Цена сделки',
      },
      emptyValue: 'не заполнено',
      followUps: 'Задачи из договорённостей',
      edit: 'Поправить значение',
      from: 'от',
      to: 'до',
      listHint: 'Через запятую',
      dealHint: 'сделка: {deal}',
    },
  },
}

const en = {
  common: { navigation: { videomeetings: 'Video meetings' } },
  videomeetings: {
    title: 'Video meetings',
    schedule: 'Schedule meeting',
    empty: 'No video meetings yet',
    join: 'Join',
    openLink: 'Open link',
    joinNow: 'Join the meeting',
    copyLink: 'Link',
    linkCopied: 'Link copied',
    channelPending: 'Sent, waiting for the provider to confirm',
    reschedule: 'Reschedule…',
    cancel: 'Cancel',
    retry: 'Retry',
    artifacts: 'Transcript and qualification draft',
    minutes: '{count} min',
    loadError: 'Failed to load video meetings',
    lead: { hot: 'Hot', warm: 'Warm', cold: 'Cold' },
    list: {
      title: 'Video meetings',
      subtitle: 'Client meetings in Google Meet and Telemost: recordings, transcripts and analysis',
      presets: {
        aria: 'List slice',
        upcoming: 'Upcoming',
        past: 'Past',
        awaiting: 'Awaiting review',
        all: 'All',
      },
      filters: {
        allManagers: 'All managers',
        period: 'Period',
        anyProvider: 'Platform: any',
        anyStatus: 'Status: any',
        lead: 'Lead',
        anyUsefulness: 'Usefulness: any',
        usefulnessFrom: 'Usefulness: {score}+',
        client: 'Client…',
        toggle: 'Filters',
      },
      sort: {
        dateDesc: 'Newest first',
        dateAsc: 'Oldest first',
        temperature: 'Hottest first',
        usefulness: 'Most useful first',
      },
      stats: {
        total: 'Meetings in period',
        hot: 'Hot leads',
        awaiting: 'Awaiting review',
        usefulness: 'Average usefulness',
      },
      columns: {
        when: 'Date and time',
        client: 'Client',
        manager: 'Manager',
        provider: 'Platform',
        status: 'Status',
        lead: 'Lead',
        usefulness: 'Usefulness',
      },
      unnamedClient: 'Unnamed client',
      deal: 'Deal',
      open: 'Open',
      empty: {
        title: 'No video meetings yet',
        description: 'Schedule one from a client or deal card and it will show up here',
      },
      emptyFiltered: {
        title: 'No meetings match these filters',
        description: 'Change the slice or reset the filters',
      },
      resetFilters: 'Reset filters',
      loadError: 'Failed to load the meetings list',
    },
    insights: {
      empty: 'Not analysed yet',
      sentiment: 'Sentiment',
      sentiments: {
        SENTIMENT_POSITIVE: '😊 positive',
        SENTIMENT_NEUTRAL: '😐 neutral',
        SENTIMENT_NEGATIVE: '😟 negative',
      },
      topics: 'Topics',
      objections: 'Objections',
      risks: 'Risks',
      agreements: 'Agreements',
    },
    info: {
      title: 'Meeting',
      client: 'Client',
      deal: 'Deal',
      manager: 'Manager',
      provider: 'Platform',
      recording: 'Recording',
      on: 'On',
      off: 'Off',
      consent: 'Consent',
      task: '"Meeting" task',
      taskCreated: 'Created',
      taskMissing: 'Not created',
      created: 'Scheduled on',
    },
    invites: {
      title: 'Invitations',
      empty: 'No invitations were sent',
      resend: 'Resend',
      resent: 'Invitation sent again',
      resendError: 'Failed to resend',
      sent: 'delivered {when}',
      pending: 'awaiting confirmation',
      failed: 'not delivered',
    },
    providers: {
      MEETING_PROVIDER_MEET: 'Google Meet',
      MEETING_PROVIDER_TELEMOST: 'Yandex Telemost',
    },
    statuses: {
      MEETING_STATUS_SCHEDULED: 'Scheduled',
      MEETING_STATUS_STARTED: 'In progress',
      MEETING_STATUS_ENDED: 'Finished',
      MEETING_STATUS_PROCESSING: 'Processing recording',
      MEETING_STATUS_READY: 'Ready',
      MEETING_STATUS_QUALIFIED: 'Reviewed',
      MEETING_STATUS_NO_RECORDING: 'No recording',
      MEETING_STATUS_FAILED: 'Processing failed',
      MEETING_STATUS_CANCELLED: 'Cancelled',
    },
    hints: {
      MEETING_STATUS_STARTED: 'recording in progress',
      MEETING_STATUS_PROCESSING: 'the transcript will appear automatically',
      MEETING_STATUS_READY: 'audio and transcript are ready',
      MEETING_STATUS_NO_RECORDING: 'no recording appeared — mark the outcome',
    },
    telemostBanner:
      'Telemost records only on demand: press “Record to Yandex Disk” when the meeting starts',
    channels: {
      INVITE_CHANNEL_WHATSAPP: 'WhatsApp',
      INVITE_CHANNEL_TELEGRAM: 'Telegram',
      INVITE_CHANNEL_ZALO: 'Zalo',
      INVITE_CHANNEL_EMAIL: 'Email',
      INVITE_CHANNEL_CALENDAR: 'Calendar',
      INVITE_CHANNEL_MANUAL_COPY: 'Manually',
    },
    modal: {
      title: 'New video meeting',
      client: 'Client',
      manager: 'Manager',
      provider: 'Platform',
      when: 'Date and time',
      duration: 'Duration',
      durationValue: '{count} minutes',
      recording: 'Call recording',
      recordingOn: 'Enabled',
      recordingOff: 'Disabled',
      recordingHint: 'The invitation tells the client that the meeting is recorded',
      channels: 'Where to send the invitation',
      noChannels: 'The client has no connected channels — send the invitation manually',
      preview: 'Invitation text',
      previewPending: 'The text appears once the meeting is created',
      createTask: 'Create a “Meeting” task',
      createTaskHint: 'The task appears in the calendar with the meeting time as its due date',
      conflict: 'The manager already has something at this time — you can still schedule it',
      noMailbox:
        'The manager has no company mailbox — a meeting cannot be scheduled on their behalf. Ask an administrator.',
      submit: 'Schedule meeting',
      created: 'Video meeting scheduled',
      createError: 'Failed to schedule the video meeting',
      telemostHint: 'Telemost records on demand — press “Record to Yandex Disk” at the start',
    },
    rescheduleModal: {
      title: 'Reschedule video meeting',
      current: 'Currently scheduled for {when}',
      hint: 'The client is notified through the same channels, the task due date follows',
      submit: 'Reschedule',
      done: 'Meeting rescheduled',
      error: 'Failed to reschedule the meeting',
    },
    cancelModal: {
      title: 'Cancel the video meeting?',
      reason: 'Reason for the client (optional)',
      hint: 'The client gets a cancellation notice and the "Meeting" task is removed.',
      submit: 'Cancel meeting',
      done: 'Meeting cancelled',
      error: 'Failed to cancel the meeting',
    },
    detail: {
      breadcrumb: 'Video meeting',
      title: 'Video meeting · {when}',
      listen: 'Play recording',
      transcript: 'Transcript',
      transcriptSearch: 'Search the transcript',
      transcriptEmpty: 'No transcript yet',
      showAll: 'Show all lines ({count})',
      backToList: 'Video meetings',
      titleFull: '{client} · {when} · {duration}',
      usefulnessBadge: 'Usefulness {score}',
      scheduledNote:
        'The meeting has not happened yet. Once recorded, the summary, transcript and card suggestions will appear here.',
      noRecordingsAccess: 'The recording and transcript require the recordings permission',
      meta: {
        recordingOn: 'Recording on',
        recordingOff: 'No recording',
        consent: {
          RECORDING_CONSENT_NOTIFIED: 'client notified',
          RECORDING_CONSENT_CONFIRMED: 'consent confirmed',
          RECORDING_CONSENT_REFUSED: 'client refused',
        },
      },
      actions: {
        copyLink: 'Copy link',
        requalify: 'Re-analyse',
        requalified: 'Meeting re-analysed',
        requalifyError: 'Failed to re-analyse',
        rescheduled: 'Meeting rescheduled',
      },
      summary: 'Meeting summary · AI',
      speakers: {
        manager: 'Manager',
        client: 'Client',
        other: 'Participant',
      },
      processing: 'The recording is being processed — the transcript will appear automatically',
      failed: 'Recording processing failed',
      noRecording: 'This meeting has no recording',
      audioError: 'Failed to get the audio link',
      loadError: 'Failed to load the meeting',
    },
    qualification: {
      title: 'Qualification draft',
      hint: 'Pick what to apply to the client card: current value → AI suggestion',
      empty: 'The model heard nothing that is not in the card already',
      apply: 'Apply selected ({count})',
      discard: 'Discard',
      applied: 'Client card updated',
      discarded: 'Draft discarded',
      applyError: 'Failed to apply the suggestions',
      resolvedApplied: 'The draft is already applied',
      resolvedDiscarded: 'Draft discarded — a new meeting will create a new one',
      note: 'The summary is added as a client note, and as a deal comment when the meeting has one',
      fields: {
        purchase_goal: 'Purchase goal',
        deal_timeline: 'Purchase timeline',
        budget: 'Budget',
        interested_property_types: 'Property type',
        interested_locations: 'Locations',
        note: 'Note',
        deal_price: 'Deal price',
      },
      emptyValue: 'empty',
      followUps: 'Tasks from agreements',
      edit: 'Adjust the value',
      from: 'from',
      to: 'to',
      listHint: 'Comma-separated',
      dealHint: 'deal: {deal}',
    },
  },
}

const vn = {
  common: { navigation: { videomeetings: 'Cuộc họp video' } },
  videomeetings: {
    title: 'Cuộc họp video',
    schedule: 'Đặt cuộc họp',
    empty: 'Chưa có cuộc họp video',
    join: 'Tham gia',
    openLink: 'Mở liên kết',
    joinNow: 'Vào cuộc họp',
    copyLink: 'Liên kết',
    linkCopied: 'Đã sao chép liên kết',
    channelPending: 'Đã gửi, đang chờ nhà cung cấp xác nhận',
    reschedule: 'Dời lịch…',
    cancel: 'Huỷ',
    retry: 'Thử lại',
    artifacts: 'Bản ghi lời và bản nháp phân loại',
    minutes: '{count} phút',
    loadError: 'Không tải được cuộc họp video',
    lead: { hot: 'Nóng', warm: 'Ấm', cold: 'Lạnh' },
    list: {
      title: 'Cuộc họp video',
      subtitle:
        'Cuộc họp với khách hàng trên Google Meet và Telemost: bản ghi, bản chép lời và phân tích',
      presets: {
        aria: 'Lát cắt danh sách',
        upcoming: 'Sắp tới',
        past: 'Đã diễn ra',
        awaiting: 'Chờ xử lý',
        all: 'Tất cả',
      },
      filters: {
        allManagers: 'Tất cả quản lý',
        period: 'Khoảng thời gian',
        anyProvider: 'Nền tảng: bất kỳ',
        anyStatus: 'Trạng thái: bất kỳ',
        lead: 'Khách tiềm năng',
        anyUsefulness: 'Hữu ích: bất kỳ',
        usefulnessFrom: 'Hữu ích: từ {score}',
        client: 'Khách hàng…',
        toggle: 'Bộ lọc',
      },
      sort: {
        dateDesc: 'Mới nhất trước',
        dateAsc: 'Cũ nhất trước',
        temperature: 'Nóng nhất trước',
        usefulness: 'Hữu ích nhất trước',
      },
      stats: {
        total: 'Cuộc họp trong kỳ',
        hot: 'Khách tiềm năng nóng',
        awaiting: 'Chờ xử lý',
        usefulness: 'Mức hữu ích trung bình',
      },
      columns: {
        when: 'Ngày và giờ',
        client: 'Khách hàng',
        manager: 'Quản lý',
        provider: 'Nền tảng',
        status: 'Trạng thái',
        lead: 'Khách tiềm năng',
        usefulness: 'Hữu ích',
      },
      unnamedClient: 'Khách hàng chưa có tên',
      deal: 'Giao dịch',
      open: 'Mở',
      empty: {
        title: 'Chưa có cuộc họp video',
        description: 'Lên lịch từ thẻ khách hàng hoặc giao dịch, cuộc họp sẽ xuất hiện ở đây',
      },
      emptyFiltered: {
        title: 'Không có cuộc họp theo bộ lọc này',
        description: 'Đổi lát cắt hoặc đặt lại bộ lọc',
      },
      resetFilters: 'Đặt lại bộ lọc',
      loadError: 'Không tải được danh sách cuộc họp',
    },
    insights: {
      empty: 'Chưa có phân tích',
      sentiment: 'Tâm trạng',
      sentiments: {
        SENTIMENT_POSITIVE: '😊 tích cực',
        SENTIMENT_NEUTRAL: '😐 trung lập',
        SENTIMENT_NEGATIVE: '😟 tiêu cực',
      },
      topics: 'Chủ đề',
      objections: 'Phản đối',
      risks: 'Rủi ro',
      agreements: 'Thoả thuận',
    },
    info: {
      title: 'Cuộc họp',
      client: 'Khách hàng',
      deal: 'Giao dịch',
      manager: 'Quản lý',
      provider: 'Nền tảng',
      recording: 'Ghi hình',
      on: 'Bật',
      off: 'Tắt',
      consent: 'Đồng ý',
      task: 'Nhiệm vụ «Cuộc họp»',
      taskCreated: 'Đã tạo',
      taskMissing: 'Chưa tạo',
      created: 'Lên lịch lúc',
    },
    invites: {
      title: 'Lời mời',
      empty: 'Chưa gửi lời mời nào',
      resend: 'Gửi lại',
      resent: 'Đã gửi lại lời mời',
      resendError: 'Không gửi lại được',
      sent: 'đã gửi {when}',
      pending: 'chờ xác nhận',
      failed: 'chưa gửi được',
    },
    providers: {
      MEETING_PROVIDER_MEET: 'Google Meet',
      MEETING_PROVIDER_TELEMOST: 'Yandex Telemost',
    },
    statuses: {
      MEETING_STATUS_SCHEDULED: 'Đã lên lịch',
      MEETING_STATUS_STARTED: 'Đang diễn ra',
      MEETING_STATUS_ENDED: 'Đã kết thúc',
      MEETING_STATUS_PROCESSING: 'Đang xử lý bản ghi',
      MEETING_STATUS_READY: 'Sẵn sàng',
      MEETING_STATUS_QUALIFIED: 'Đã phân tích',
      MEETING_STATUS_NO_RECORDING: 'Không có bản ghi',
      MEETING_STATUS_FAILED: 'Xử lý thất bại',
      MEETING_STATUS_CANCELLED: 'Đã huỷ',
    },
    hints: {
      MEETING_STATUS_STARTED: 'đang ghi',
      MEETING_STATUS_PROCESSING: 'bản ghi lời sẽ xuất hiện tự động',
      MEETING_STATUS_READY: 'âm thanh và bản ghi lời đã sẵn sàng',
      MEETING_STATUS_NO_RECORDING: 'không có bản ghi — hãy đánh dấu kết quả',
    },
    telemostBanner: 'Telemost chỉ ghi khi được bật: đầu cuộc họp hãy nhấn «Ghi vào Yandex Disk»',
    channels: {
      INVITE_CHANNEL_WHATSAPP: 'WhatsApp',
      INVITE_CHANNEL_TELEGRAM: 'Telegram',
      INVITE_CHANNEL_ZALO: 'Zalo',
      INVITE_CHANNEL_EMAIL: 'Email',
      INVITE_CHANNEL_CALENDAR: 'Lịch',
      INVITE_CHANNEL_MANUAL_COPY: 'Thủ công',
    },
    modal: {
      title: 'Cuộc họp video mới',
      client: 'Khách hàng',
      manager: 'Quản lý',
      provider: 'Nền tảng',
      when: 'Ngày và giờ',
      duration: 'Thời lượng',
      durationValue: '{count} phút',
      recording: 'Ghi cuộc trò chuyện',
      recordingOn: 'Bật',
      recordingOff: 'Tắt',
      recordingHint: 'Lời mời sẽ báo cho khách hàng rằng cuộc họp được ghi lại',
      channels: 'Gửi lời mời qua đâu',
      noChannels: 'Khách hàng chưa có kênh nào — hãy gửi lời mời thủ công',
      preview: 'Nội dung lời mời',
      previewPending: 'Nội dung xuất hiện sau khi tạo cuộc họp',
      createTask: 'Tạo công việc «Cuộc họp»',
      createTaskHint: 'Công việc sẽ xuất hiện trong lịch với hạn đúng giờ họp',
      conflict: 'Quản lý đã có lịch vào giờ này — vẫn có thể đặt cuộc họp',
      noMailbox:
        'Quản lý chưa có hộp thư công ty — không thể đặt cuộc họp thay họ. Hãy liên hệ quản trị viên.',
      submit: 'Đặt cuộc họp',
      created: 'Đã đặt cuộc họp video',
      createError: 'Không đặt được cuộc họp video',
      telemostHint: 'Telemost ghi thủ công — hãy nhấn «Ghi vào Yandex Disk» khi bắt đầu',
    },
    rescheduleModal: {
      title: 'Dời cuộc họp video',
      current: 'Hiện đặt vào {when}',
      hint: 'Khách hàng được báo qua cùng các kênh, hạn công việc cũng đổi theo',
      submit: 'Dời lịch',
      done: 'Đã dời cuộc họp',
      error: 'Không dời được cuộc họp',
    },
    cancelModal: {
      title: 'Huỷ cuộc họp video?',
      reason: 'Lý do cho khách (không bắt buộc)',
      hint: 'Khách sẽ nhận thông báo huỷ, nhiệm vụ «Cuộc họp» sẽ bị gỡ.',
      submit: 'Huỷ cuộc họp',
      done: 'Đã huỷ cuộc họp',
      error: 'Không huỷ được cuộc họp',
    },
    detail: {
      breadcrumb: 'Cuộc họp video',
      title: 'Cuộc họp video · {when}',
      listen: 'Nghe bản ghi',
      transcript: 'Bản ghi lời',
      transcriptSearch: 'Tìm trong bản ghi lời',
      transcriptEmpty: 'Chưa có bản ghi lời',
      showAll: 'Hiện tất cả câu thoại ({count})',
      backToList: 'Cuộc họp video',
      titleFull: '{client} · {when} · {duration}',
      usefulnessBadge: 'Hữu ích {score}',
      scheduledNote:
        'Cuộc họp chưa diễn ra. Sau khi ghi hình, tóm tắt, bản chép lời và đề xuất cho thẻ sẽ xuất hiện ở đây.',
      noRecordingsAccess: 'Bản ghi và bản chép lời chỉ mở với quyền xem bản ghi',
      meta: {
        recordingOn: 'Đang ghi hình',
        recordingOff: 'Không ghi hình',
        consent: {
          RECORDING_CONSENT_NOTIFIED: 'đã thông báo khách',
          RECORDING_CONSENT_CONFIRMED: 'khách đã đồng ý',
          RECORDING_CONSENT_REFUSED: 'khách từ chối',
        },
      },
      actions: {
        copyLink: 'Sao chép liên kết',
        requalify: 'Phân tích lại',
        requalified: 'Đã phân tích lại cuộc họp',
        requalifyError: 'Không phân tích lại được',
        rescheduled: 'Đã dời cuộc họp',
      },
      summary: 'Tóm tắt cuộc họp · AI',
      speakers: {
        manager: 'Quản lý',
        client: 'Khách hàng',
        other: 'Người tham gia',
      },
      processing: 'Bản ghi đang được xử lý — bản ghi lời sẽ xuất hiện tự động',
      failed: 'Xử lý bản ghi thất bại',
      noRecording: 'Cuộc họp này không có bản ghi',
      audioError: 'Không lấy được liên kết âm thanh',
      loadError: 'Không tải được cuộc họp',
    },
    qualification: {
      title: 'Bản nháp phân loại',
      hint: 'Chọn nội dung áp dụng vào hồ sơ khách: giá trị hiện tại → đề xuất của AI',
      empty: 'Mô hình không nghe thấy gì mới so với hồ sơ',
      apply: 'Áp dụng mục đã chọn ({count})',
      discard: 'Bỏ qua',
      applied: 'Đã cập nhật hồ sơ khách hàng',
      discarded: 'Đã bỏ bản nháp',
      applyError: 'Không áp dụng được đề xuất',
      resolvedApplied: 'Bản nháp đã được áp dụng',
      resolvedDiscarded: 'Bản nháp đã bỏ — cuộc họp mới sẽ tạo bản khác',
      note: 'Tóm tắt sẽ thành ghi chú của khách, và thành bình luận trong giao dịch nếu có',
      fields: {
        purchase_goal: 'Mục đích mua',
        deal_timeline: 'Thời hạn mua',
        budget: 'Ngân sách',
        interested_property_types: 'Loại bất động sản',
        interested_locations: 'Khu vực',
        note: 'Ghi chú',
        deal_price: 'Giá giao dịch',
      },
      emptyValue: 'chưa có',
      followUps: 'Nhiệm vụ từ thoả thuận',
      edit: 'Sửa giá trị',
      from: 'từ',
      to: 'đến',
      listHint: 'Cách nhau bằng dấu phẩy',
      dealHint: 'giao dịch: {deal}',
    },
  },
}

export const videomeetingsMessages = { ru, en, vn }
